import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'react-apollo';
import { Modal, message } from 'antd';

import BizInput from '../../components/UI/BizInput';

import QUERY from '../../graphql/queries/createLeadQueries.graphql';
import MUTATION from '../../graphql/mutations/newAssociateMutation.graphql';

class AssociateCreateDialog extends Component {
  state = {
    name: '',
    email: '',
    mobile: '',
  };

  handleOk = () => {
    this.props.mutate({
      variables: this.state,
      update: (cache, { data: { newAssociate } }) => {
        const data = cache.readQuery({
          query: QUERY,
        });
        if (!Array.isArray(data.associates)) data.associates = [];
        data.associates.push(newAssociate);
        cache.writeQuery({ query: QUERY, data });
      },
    })
      .then(() => {
        message.success('Success!');
        this.setState({
          name: '',
          email: '',
          mobile: '',
        });
        this.props.handleState('associateCreateDialog', false);
      })
      .catch((mutateErr) => {
        console.error(mutateErr);
        message.error(mutateErr.message);
      });
  };

  render() {
    const {
      name,
      email,
      mobile,
    } = this.state;

    return (
      <Modal
        title="Create new associate"
        visible={this.props.open}
        onCancel={() => { this.props.handleState('associateCreateDialog', false); }}
        onOk={this.handleOk}
      >
        <div>
          <table>
            <tbody>
              <tr>
                <td>Name</td>
                <td>
                  <BizInput
                    name="name"
                    theme="lac"
                    onChange={(value) => { this.setState({ name: value }); }}
                    value={name}
                  />
                </td>
              </tr>
              <tr>
                <td>Mobile</td>
                <td>
                  <BizInput
                    theme="lac"
                    name="mobile"
                    onChange={(value) => { this.setState({ mobile: value }); }}
                    value={mobile}
                  />
                </td>
              </tr>
              <tr>
                <td>Email</td>
                <td>
                  <BizInput
                    theme="lac"
                    name="email"
                    onChange={(value) => { this.setState({ email: value }); }}
                    value={email}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </Modal>
    );
  }
}

AssociateCreateDialog.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  open: PropTypes.bool,
  handleState: PropTypes.func.isRequired,
  mutate: PropTypes.func.isRequired,
};

AssociateCreateDialog.defaultProps = {
  open: false,
};

export default graphql(MUTATION)(AssociateCreateDialog);



// WEBPACK FOOTER //
// ./src/pages/leads/AssociateCreateDialog.jsx